import PropTypes from 'prop-types';
import { notification } from 'antd';
import React, { useState, useEffect,useRef } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RegistrationLayout from 'shared/components/Layouts/RegistrationPageLayout';
import RegistrationForm from 'shared/components/Layouts/Registration/FormContainer';
import RegistrationOptions from 'shared/components/Layouts/Registration/RegistrationOptions';
import {
  verifyUserAuth, setVerifyUserData
} from 'features/RegistrationContainer/redux/registrationActions';
import {
  loginRequestBegin,
  loginRequestError,
  clearLoginError,
  setCanAccessAdminDashboard,
  setCanAccessVolunteerDashboard,
  resetAuth,
  resetLoadingUserState
} from 'features/Authentication/redux/authActions';
//import auth from 'Auth';
import { handleRoleAccess } from 'utils/access';
import { processAuthResult } from 'utils/authorize';
import LoginLoadingOverlay from './LoginLoadingOverlay';
import Auth from '../../../../Auth';

const LoginContainer = (props) => {
  const { 
    history, 
    authorized,
    error,
    loadingUser,
  } = props;
  const { t } = useTranslation();
  const [checkingAuth, setCheckingAuth] = useState(true);
  const {href} = window.location||{};
  const authHandledRef = useRef(false);
  const popupCheckIntervalRef = useRef(null);

  const Url = new URL(href);
  const code = Url.searchParams.get('code');
  const email = Url.searchParams.get('email');
  const verification = Url.searchParams.get('verification');

  const handleAuthRedirection = async ()=>{
    let meSucceeded = false;
    try{
      const authResult = await Auth.GetInstance().handleAuthentication();
      meSucceeded = true;
      if(authResult){
        const roleData = await processAuthResult(authResult);
        if (!roleData) {
          setCheckingAuth(false);
          return;
        }
        handleRoleAccess({
          ...props,
          ...roleData
        });
      } else {
        setCheckingAuth(false);
      }
    }catch(err){
      setCheckingAuth(false);
      if (meSucceeded) {
        props.loginRequestError(err.message || 'Login failed');
      }
    }
  }


  useEffect(()=>{
     // Run only if NOT coming from popup
    if (!authHandledRef.current) {
      handleAuthRedirection();
    }
  },[])

  const startPopupTracking = () => {
     // clear any previous interval
  if (popupCheckIntervalRef.current) {
    clearInterval(popupCheckIntervalRef.current);
  }

    popupCheckIntervalRef.current = setInterval(() => {
      const popup = Auth.GetInstance().authPopup;

      if (!popup) return;

      if (popup.closed) {
        clearInterval(popupCheckIntervalRef.current);

        if (!authHandledRef.current) {
          console.log("Popup closed without login");

          props.resetLoadingUserState();

        }
      }
    }, 500);
};

  useEffect(() => {
    //message handler for receiving messages from the popup window after successful login
  const handler = (event) => {
    if (event.origin !== window.location.origin) return;

    if (event.data.type === "LOGIN_SUCCESS") {
      if (authHandledRef.current) return;

      console.log("Login successful");
      authHandledRef.current = true;
        // CLEAR interval on success
      if (popupCheckIntervalRef.current) {
        clearInterval(popupCheckIntervalRef.current);
      }

      handleAuthRedirection();
    }
  };

  window.addEventListener("message", handler);

    return () => {
    window.removeEventListener("message", handler);
  };
}, []);

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Error',
        description: error,
        // used to clear error message in the url after notification is closed.
        onClose: ()=>{
          props.clearLoginError();
          const {location} = history||{};
          const {pathname} = location||{};
          if(pathname && history){
            history.push({pathname, search:''})
          }
        }
      });
    }
    if (verification === 'true' && code && email) {
      const payload = {
        code,
        email: email.replace(/\s/g, '+'),
        verified: false
      };
      // For BFF: Check if user is already authenticated
      if (authorized) {
        props.verifyUserAuth(payload, history);
      } else {
        props.setVerifyUserData(payload);
      }
    }
  }, [code, email, error, verification, authorized]);

  const handleGoogleSignIn = () => {
    // BFF-based authentication - redirect to BFF login endpoint
    // No callback needed as BFF handles the redirect flow
    props.loginRequestBegin();
    authHandledRef.current = false;
    Auth.GetInstance().googleAuthentication();
    startPopupTracking(); // start tracking popup
  };

  if (authorized) {
    return <Redirect to='/volunteer' />
  }

  const handleAccountSignIn = () => {
    // BFF-based authentication - redirect to BFF login endpoint
    // No callback needed as BFF handles the redirect flow
    props.loginRequestBegin();
    authHandledRef.current = false;
    Auth.GetInstance().accountAuthentication();
    startPopupTracking(); // start tracking popup 
  };

  const options = [
    //Removing Google Sign-In option as per new requirements, but keeping the code for future use if needed.
   // { text: `${t('signinGoogleLabel')}`, handleClick: handleGoogleSignIn },
    { text: `${t('signinUniqueLabel')}`, handleClick: handleAccountSignIn }
  ];

  return (
    <RegistrationLayout>
      <RegistrationForm
        error={error}
        removeError={props.clearLoginError}
        title={t('signInLabel')}
      >
        <div className='registration__signin-form'>
          <RegistrationOptions
            options={options}
          />
          <LoginLoadingOverlay loading={checkingAuth || loadingUser}/>
        </div>
      </RegistrationForm>
    </RegistrationLayout>
  );
};

LoginContainer.propTypes = {
  loadingUser: PropTypes.bool.isRequired,
  authorized: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => {
  const {
    auth: { authorized, loadingUser, error, auth0Authorized}
  } = state;
  return {
    authorized,
    loadingUser,
    error,
    auth0Authorized
  };
};

const mapDispatchToProps = {
  verifyUserAuth,
  setVerifyUserData,
  loginRequestBegin,
  loginRequestError,
  clearLoginError,
  setAdminDashboardAccess: setCanAccessAdminDashboard,
  setVolunteerDashboardAccess: setCanAccessVolunteerDashboard,
  resetAuthenticationState: resetAuth,
  resetLoadingUserState
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
